import { STORAGE } from "@constants/Storage";
import { PATHS } from "@constants/Paths";
export const getUserContext = () => {
    let userContext = null;
    try {
        const userDetailsString = sessionStorage.getItem(STORAGE.USER_CONTEXT);
        userContext = (userDetailsString && JSON.parse(userDetailsString)) || null;
    }
    catch (_a) {
        console.log("Session Storage access issue!!!");
    }
    return userContext;
};
export const storeUserContext = (useContext) => {
    try {
        sessionStorage.setItem(STORAGE.USER_CONTEXT, JSON.stringify(useContext));
    }
    catch (_a) {
        console.log("Session Storage access issue!!!");
    }
};
export const getRedirectPathAfterLogin = (user) => {
    return PATHS.DASHBOARD;
};
